/**
 * @const spartaContainerSelector
 * @description query selector for Sparta applications
 */
const spartaContainerSelector = '[data-sparta-wrapper]';

/**
 * @const spartaWidgetContainerString
 * @description String for Sparta widgets
 */
const spartaWidgetContainerString = 'data-sparta-widget';

/**
 * @const spartaWidgetContainerSelector
 * @description query selector for Sparta widgets
 */
const spartaWidgetContainerSelector = `[${spartaWidgetContainerString}]`;

/**
 * @const utilityLoadingClass
 * @description String for holding the class name we'll remove from the application container when our utility has initialized
 */
const utilityLoadingClass = 'sparta-media-query-utility-loading';

/**
 * @const spartaWidgetResizeDebounceDelay
 * @description debounce delay for window.onresize event for widgets
 */
const spartaWidgetResizeDebounceDelay = 200;

/**
 * @const mediaQueryViewportString
 * @description string used in store to denote viewport media query
 */
const mediaQueryViewportString = 'viewport';

/**
 * @const mediaQueryOrientationString
 * @description string used in store to denote orientation media query
 */
const mediaQueryOrientationString = 'orientation';

/**
 * @const mediaQueryResolutionString
 * @description string used in store to denote resolution media query
 */
const mediaQueryResolutionString = 'resolution';

/**
 * @const mediaQueryUpString
 * @description string used for our *-up class names
 */
const mediaQueryUpString = 'up';

/**
 * @const mediaQueryOnlyString
 * @description string used for our *-only class names
 */
const mediaQueryOnlyString = 'only';

/**
 * @const spartaStoreNamespace
 * @description namespace for mediaquery utility data in sparta store
 */
const spartaStoreNamespace = 'currentMQ';

/**
 * @const spartaStoreMediaQueriesKey
 * @description namespace key for media query booleans
 */
const spartaStoreMediaQueriesKey = 'mediaQueries';

/**
 * @const xsmallMinWidth
 * @description min width for xsmall viewport, we start at 1px so matchMedia works
 */
const xsmallMinWidth = 1;

/**
 * @const smallMinWidth
 * @description min width for small viewport, we start at 1px so matchMedia works
 */
const smallMinWidth = 1;

/**
 * @const smallMidMinWidth
 * @description min width for small-mid viewport
 */
const smallMidMinWidth = 375;

/**
 * @const smallPlusMinWidth
 * @description min width for small-plus viewport
 */
const smallPlusMinWidth = 414;

/**
 * @const mediumMinWidth
 * @description min width for medium viewport
 */
const mediumMinWidth = 768;

/**
 * @const largeMinWidth
 * @description min width for large viewport
 */
const largeMinWidth = 1025;

/**
 * @const largeCenteredMinWidth
 * @description width that is larger than row width + gutters and we need to switch to auto
 * @deprecated
 */
const largeCenteredMinWidth = 1296;

/**
 * @const xlargeMinWidth
 * @description min width for xlarge viewport
 */
const xlargeMinWidth = 1296;

/**
 * @const xxlargeMinWidth
 * @description min width for xxlarge viewport
 */
const xxlargeMinWidth = 1440;

/**
 * @const xsmallViewportName
 * @description string to hold xsmall viewport short name
 */
const xsmallViewportName = 'xsmall';

/**
 * @const xsmallViewportString
 * @description string to hold xsmall viewport name
 */
const xsmallViewportString = xsmallViewportName;

/**
 * @const smallViewportName
 * @description string to hold small viewport short name
 */
const smallViewportName = 'small';

/**
 * @const smallViewportString
 * @description string to hold small viewport name
 */
const smallViewportString = smallViewportName;

/**
 * @const smallMidViewportName
 * @description string to hold smallMid viewport short name
 */
const smallMidViewportName = 'smallMid';

/**
 * @const smallMidViewportString
 * @description string to hold smallMid viewport name
 */
const smallMidViewportString = smallMidViewportName;

/**
 * @const smallPlusViewportName
 * @description string to hold smallPlus viewport short name
 */
const smallPlusViewportName = 'smallPlus';

/**
 * @const smallPlusViewportString
 * @description string to hold smallPlus viewport name
 */
const smallPlusViewportString = smallPlusViewportName;

/**
 * @const smallPlusViewportName2
 * @description string to hold small-plus viewport short name
 */
const smallPlusViewportName2 = 'small-plus';

/**
 * @const smallPlusViewportString2
 * @description string to hold small-plus viewport name
 */
const smallPlusViewportString2 = smallPlusViewportName2;

/**
 * @const mediumViewportName
 * @description string to hold medium viewport short name
 */
const mediumViewportName = 'medium';

/**
 * @const mediumViewportString
 * @description string to hold medium viewport name
 */
const mediumViewportString = mediumViewportName;

/**
 * @const largeViewportName
 * @description string to hold large viewport short name
 */
const largeViewportName = 'large';

/**
 * @const largeViewportString
 * @description string to hold large viewport name
 */
const largeViewportString = largeViewportName;

/**
 * @const xlargeViewportName
 * @description string to hold xlarge viewport short name
 */
const xlargeViewportName = 'xlarge';

/**
 * @const xlargeViewportString
 * @description string to hold xlarge viewport name
 */
const xlargeViewportString = xlargeViewportName;

/**
 * @const xxlargeViewportName
 * @description string to hold xxlarge viewport short name
 */
const xxlargeViewportName = 'xxlarge';

/**
 * @const xxlargeViewportString
 * @description string to hold xxlarge viewport name
 */
const xxlargeViewportString = xxlargeViewportName;

/**
 * @const largeCenteredViewportName
 * @description string to hold name for viewport needed to deal with centering the large grid beyond the max row width
 * @deprecated
 */
const largeCenteredViewportName = 'largeCentered';

/**
 * @const landscapeOrientationName
 * @description string to hold landscape orientation name
 */
const landscapeOrientationName = 'landscape';

/**
 * @const portraitOrientationName
 * @description string to hold portrait orientation name
 */
const portraitOrientationName = 'portrait';

/**
 * @const defaultResolutionnName
 * @description string to hold default resolution name
 */
const defaultResolutionName = 'standard';

/**
 * @const retinaResolutionnName
 * @description string to hold retina resolution name
 */
const retinaResolutionName = 'retina';

/**
 * @const xsmallMediaQueryString
 * @description string to hold xsmall media query definition
 */
const xsmallMediaQueryString = `only screen and (min-width: ${xsmallMinWidth}px)`;

/**
 * @const smallMediaQueryString
 * @description string to hold small media query definition
 */
const smallMediaQueryString = `only screen and (min-width: ${smallMinWidth}px)`;

/**
 * @const smallMidMediaQueryString
 * @description string to hold small-mid media query definition
 */
const smallMidMediaQueryString = `only screen and (min-width: ${smallMidMinWidth}px)`;

/**
 * @const smallPlusMediaQueryString
 * @description string to hold small-mid media query definition
 */
const smallPlusMediaQueryString = `only screen and (min-width: ${smallPlusMinWidth}px)`;

/**
 * @const mediumMediaQueryString
 * @description string to hold medium media query definition
 */
const mediumMediaQueryString = `only screen and (min-width: ${mediumMinWidth}px)`;

/**
 * @const largeMediaQueryString
 * @description string to hold large media query definition
 */
const largeMediaQueryString = `only screen and (min-width: ${largeMinWidth}px)`;

/**
 * @const largeCenteredMediaQueryString
 * @description string to hold largeCentered media query definition
 * @deprecated
 */
const largeCenteredMediaQueryString = `only screen and (min-width: ${largeCenteredMinWidth}px)`;

/**
 * @const xlargeMediaQueryString
 * @description string to hold xlarge media query definition
 */
const xlargeMediaQueryString = `only screen and (min-width: ${xlargeMinWidth}px)`;

/**
 * @const xxlargeMediaQueryString
 * @description string to hold xxlarge media query definition
 */
const xxlargeMediaQueryString = `only screen and (min-width: ${xxlargeMinWidth}px)`;

/**
 * @const portraitMediaQueryString
 * @description string to hold portrait media query definition
 */
const portraitMediaQueryString = `only screen and (orientation: ${portraitOrientationName})`;

/**
 * @const landscapeMediaQueryString
 * @description string to hold landscape media query definition
 */
const landscapeMediaQueryString = `only screen and (orientation: ${landscapeOrientationName})`;

/**
 * @const defaultResolutionMediaQueryString
 * @description string to hold non-retina media query definition
 */
const defaultResolutionMediaQueryString = `not screen and (min-device-pixel-ratio: 2), not screen and (min-resolution: 192dpi), not screen and (min-resolution: 2dppx)`;

/**
 * @const retinaResolutionMediaQueryString
 * @description string to hold retina media query definition
 */
const retinaResolutionMediaQueryString = `only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)`;

/**
 * @const viewportNames
 * @description object containing viewport names mapped to simple keys in case they change in the future
 */
const viewportNames = {
  [xsmallViewportName]: xsmallViewportString,
  [smallViewportName]: smallViewportString,
  [smallMidViewportName]: smallMidViewportString,
  [smallPlusViewportName]: smallPlusViewportString,
  [smallPlusViewportName2]: smallPlusViewportString2,
  [mediumViewportName]: mediumViewportString,
  [largeViewportName]: largeViewportString,
  [largeCenteredViewportName]: largeCenteredViewportName,
  [xlargeViewportName]: xlargeViewportString,
  [xxlargeViewportName]: xxlargeViewportString
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  spartaContainerSelector: spartaContainerSelector,
  spartaWidgetContainerString: spartaWidgetContainerString,
  spartaWidgetContainerSelector: spartaWidgetContainerSelector,
  utilityLoadingClass: utilityLoadingClass,
  spartaWidgetResizeDebounceDelay: spartaWidgetResizeDebounceDelay,
  mediaQueryViewportString: mediaQueryViewportString,
  mediaQueryOrientationString: mediaQueryOrientationString,
  mediaQueryResolutionString: mediaQueryResolutionString,
  mediaQueryUpString: mediaQueryUpString,
  mediaQueryOnlyString: mediaQueryOnlyString,
  spartaStoreNamespace: spartaStoreNamespace,
  spartaStoreMediaQueriesKey: spartaStoreMediaQueriesKey,
  xsmallMinWidth: xsmallMinWidth,
  smallMinWidth: smallMinWidth,
  smallMidMinWidth: smallMidMinWidth,
  smallPlusMinWidth: smallPlusMinWidth,
  mediumMinWidth: mediumMinWidth,
  largeMinWidth: largeMinWidth,
  largeCenteredMinWidth: largeCenteredMinWidth,
  xlargeMinWidth: xlargeMinWidth,
  xxlargeMinWidth: xxlargeMinWidth,
  xsmallViewportName: xsmallViewportName,
  xsmallViewportString: xsmallViewportString,
  smallViewportName: smallViewportName,
  smallViewportString: smallViewportString,
  smallMidViewportName: smallMidViewportName,
  smallMidViewportString: smallMidViewportString,
  smallPlusViewportName: smallPlusViewportName,
  smallPlusViewportString: smallPlusViewportString,
  smallPlusViewportName2: smallPlusViewportName2,
  smallPlusViewportString2: smallPlusViewportString2,
  mediumViewportName: mediumViewportName,
  mediumViewportString: mediumViewportString,
  largeViewportName: largeViewportName,
  largeViewportString: largeViewportString,
  xlargeViewportName: xlargeViewportName,
  xlargeViewportString: xlargeViewportString,
  xxlargeViewportName: xxlargeViewportName,
  xxlargeViewportString: xxlargeViewportString,
  largeCenteredViewportName: largeCenteredViewportName,
  landscapeOrientationName: landscapeOrientationName,
  portraitOrientationName: portraitOrientationName,
  defaultResolutionName: defaultResolutionName,
  retinaResolutionName: retinaResolutionName,
  xsmallMediaQueryString: xsmallMediaQueryString,
  smallMediaQueryString: smallMediaQueryString,
  smallMidMediaQueryString: smallMidMediaQueryString,
  smallPlusMediaQueryString: smallPlusMediaQueryString,
  mediumMediaQueryString: mediumMediaQueryString,
  largeMediaQueryString: largeMediaQueryString,
  largeCenteredMediaQueryString: largeCenteredMediaQueryString,
  xlargeMediaQueryString: xlargeMediaQueryString,
  xxlargeMediaQueryString: xxlargeMediaQueryString,
  portraitMediaQueryString: portraitMediaQueryString,
  landscapeMediaQueryString: landscapeMediaQueryString,
  defaultResolutionMediaQueryString: defaultResolutionMediaQueryString,
  retinaResolutionMediaQueryString: retinaResolutionMediaQueryString,
  viewportNames: viewportNames
});

/**
 * @class MediaQueryListModel
 * @description simple model for our media query list
 */
class MediaQueryListModel {
  /**
   * @method constructor
   * @description initialize a new instance of MediaQueryListModel
   * @param {String} type the type of media query
   * @param {String} name the name of the media query
   * @param {String} mediaQuery the actual media query String
   * @param {Number} width the minimum width of the media query
   * @returns {Object}
   */
  constructor(type, name, mediaQuery, width) {
    this.type = type;
    this.name = name;
    this.mediaQuery = mediaQuery;
    if (width) {
      this.width = width;
    }
  }
}

/**
 * @const mediaQueriesList
 * @description this will become our Map that references the various media queries and viewports
 */
const mediaQueriesList = [new MediaQueryListModel(mediaQueryViewportString, viewportNames.xsmall, xsmallMediaQueryString, xsmallMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.small, smallMediaQueryString, smallMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.smallMid, smallMidMediaQueryString, smallMidMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.smallPlus, smallPlusMediaQueryString, smallPlusMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.medium, mediumMediaQueryString, mediumMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.large, largeMediaQueryString, largeMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.largeCentered, largeCenteredMediaQueryString, largeCenteredMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.xlarge, xlargeMediaQueryString, xlargeMinWidth), new MediaQueryListModel(mediaQueryViewportString, viewportNames.xxlarge, xxlargeMediaQueryString, xxlargeMinWidth), new MediaQueryListModel(mediaQueryOrientationString, landscapeOrientationName, landscapeMediaQueryString), new MediaQueryListModel(mediaQueryOrientationString, portraitOrientationName, portraitMediaQueryString), new MediaQueryListModel(mediaQueryResolutionString, defaultResolutionName, defaultResolutionMediaQueryString), new MediaQueryListModel(mediaQueryResolutionString, retinaResolutionName, retinaResolutionMediaQueryString)];
var index = {
  mediaQueriesList,
  constants,
  MediaQueryListModel
};

export { index as default };
